// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3g87h","buttons":"Footer_buttons__f2diS"};